import {
  breakpoint,
  Heading,
  LinkTextStyles,
  CombinedLinkTextProps,
} from '@grays-npm/component-library';
import styled from 'styled-components';
import { Link } from 'react-router-dom';

export const StyledHeading = styled(Heading)`
  ${({ theme }) => theme.typography.headings[4]['xl']};

  ${breakpoint('lg')`
    ${({ theme }) => theme.typography.headings[3]['xl']};
  `}
`;

export const NamedHeading = styled(StyledHeading)`
  margin-bottom: ${({ theme }) => theme.spacings[5].rem};

  ${breakpoint('lg')`
      margin-bottom: ${({ theme }) => theme.spacings[7].rem};
  `}
`;

export const LinkToText = styled(Link)<
  React.HTMLAttributes<HTMLDivElement> & CombinedLinkTextProps
>`
  ${LinkTextStyles}
`;

export const ActionText = styled.div<
  React.HTMLAttributes<HTMLDivElement> & CombinedLinkTextProps
>`
  ${LinkTextStyles}
`;
